'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var ModCloudy = function (_React$Component) {
    _inherits(ModCloudy, _React$Component);

    function ModCloudy() {
        _classCallCheck(this, ModCloudy);

        return _possibleConstructorReturn(this, (ModCloudy.__proto__ || Object.getPrototypeOf(ModCloudy)).apply(this, arguments));
    }

    _createClass(ModCloudy, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M9.744 8.861c-0.010 0-0.020 0.010-0.040 0.010-2.821 0.040-5.109 2.307-5.139 5.12-2.519 0.020-4.565 2.065-4.565 4.574 0 2.53 2.066 4.574 4.605 4.574h16.384c2.54 0 4.605-2.044 4.605-4.574 0-2.499-2.036-4.533-4.555-4.564-0.836-1.761-2.619-2.995-4.705-2.995-0.736 0-1.421 0.182-2.056 0.455-0.907-1.548-2.57-2.601-4.494-2.601-0.009 0-0.019 0-0.039 0v0zM9.784 9.428c0.010 0 0.020 0 0.030 0 1.793 0.010 3.335 1.032 4.101 2.499 0.071 0.131 0.252 0.192 0.383 0.131 0.614-0.304 1.3-0.476 2.036-0.476 1.935 0 3.597 1.164 4.302 2.823 0.040 0.101 0.151 0.172 0.262 0.162 0.081 0 0.111-0.010 0.090-0.010 2.237 0 4.041 1.801 4.041 4.007 0 2.216-1.804 4.007-4.041 4.007h-16.384c-2.237 0-4.041-1.791-4.041-4.007 0-2.206 1.804-4.007 4.041-4.007 0.061 0 0.131 0.020 0.232 0.020 0.151 0.010 0.302-0.131 0.302-0.293-0.010-0.081-0.010-0.162-0.010-0.243 0-2.551 2.076-4.615 4.655-4.615v0z' })
            );
        }
    }]);

    return ModCloudy;
}(_react2.default.Component);

ModCloudy.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = ModCloudy;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/weather/mod-cloudy.js
// module id = 1137
// module chunks = 0